var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDownloadPrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5008 0.333328C6.86899 0.333328 7.16747 0.631805 7.16747 0.999995V7.43672L9.33649 5.43015C9.60676 5.18012 10.0286 5.19653 10.2786 5.46681C10.5286 5.73708 10.5122 6.15887 10.2419 6.4089L6.95352 9.45101C6.698 9.6874 6.30361 9.6874 6.04808 9.45101L2.75967 6.4089C2.4894 6.15887 2.47299 5.73708 2.72302 5.46681C2.97305 5.19653 3.39484 5.18012 3.66512 5.43015L5.83414 7.43672V0.999995C5.83414 0.631805 6.13261 0.333328 6.5008 0.333328ZM0.689712 12.1227C0.94696 11.8593 1.36904 11.8543 1.63246 12.1115C1.77609 12.2518 1.97419 12.3333 2.18397 12.3333H10.816C11.0258 12.3333 11.2239 12.2518 11.3675 12.1115C11.631 11.8543 12.053 11.8593 12.3103 12.1227C12.5675 12.3861 12.5625 12.8082 12.2991 13.0654C11.9031 13.4521 11.3694 13.6667 10.816 13.6667H2.18397C1.63062 13.6667 1.09686 13.4521 0.700879 13.0654C0.437464 12.8082 0.432464 12.3861 0.689712 12.1227Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadPrimary);
export default __webpack_public_path__ + "static/media/ic-download-primary.dc9661cfc709e5fcb8cdeaac29b2326e.svg";
export { ForwardRef as ReactComponent };